export default __webpack_public_path__ + "static/media/exportPopup.3b52647c.svg";